import React, { useState } from "react";
import { Popover } from "@mui/material";
import { Sketch } from "@uiw/react-color";
import { commonStyles } from "../commonStyles";

type ColorPickerProps = {
  value: string;
  onChange: (hex: string) => void;
  label?: string;
  disabled?: boolean;
};

const ColorPicker = ({
  value,
  onChange,
  label,
  disabled,
}: ColorPickerProps): React.ReactElement => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        disabled={disabled}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        className="h-9 w-9 rounded border border-gray-300 shadow-sm disabled:opacity-50"
        style={{ backgroundColor: value || commonStyles.cpaGold }}
        aria-label={label || "Select color"}
      />
      {label ? <span className="text-sm text-gray-700">{label}</span> : null}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Sketch
          color={value || commonStyles.cpaGold}
          disableAlpha
          onChange={(color) => onChange(color.hex)}
        />
      </Popover>
    </div>
  );
};

export default ColorPicker;
